import './App.css';
import axios from "axios";
import { Form, Button} from 'semantic-ui-react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';


export default function App() {
 const form = useRef();

 const sendEmail = (e) => {
   //e.preventDefault(); // prevents the page from reloading when you hit “Send”
   
   emailjs.sendForm('service_s2ijd2r', 'template_1e7z064', form.current, '6KnUEwiWyBozvNKRU')
     .then((result) => {
  alert('Děkujeme za Vaše hlasování!'); 
  reset({name:"", email:"", choice:"", libilo:"", vylepseni:"", checkBox:""});
  window.scrollTo(0, 0);
   emailjs.sendForm('service_s2ijd2r', 'template_3w70djt', form.current, '6KnUEwiWyBozvNKRU')
 
     }, (error) => {
         alert('Je nám to líto! Něco se pokazilo! Zkuste to, prosím, znovu.');
     });
 };

const methods = useForm();
    const { register, control, handleSubmit, reset, formState: { errors } } = useForm();

    return (
        <div>
            <form ref={form} onSubmit={handleSubmit(sendEmail)}>
                
                
		    <div className="form-floating mb-3">
                    
                    <input className="form-control" 
                        type="text" placeholder=""
                        {...register("name", { required: true})}
                    />
		    <label >Jméno a příjmení<span className="required">*</span></label>
		    </div>
                {errors.name && <p style={{color:"red"}}>Pole Jméno a příjmení je požadováno</p>}
		        
        	 <div className="form-floating mb-3">                    
                    <input
                        className="form-control" id="email" type="email" placeholder=""
                        {...register("email",{
                                required: true,
                                pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            })}
                    />
		    <label>E-mail<span className="required">*</span></label>
		    </div>

		{errors.email && <p style={{color:"red"}}>Pole E-mail je požadováno</p>}

		 {/*   <div className="form-floating mb-3">                    
                    <input
                        className="form-control" id="phone" type="phone" placeholder=""
                        {...register("phone",{pattern: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i})}
                    />
		    <label>Telefon</label>
		    </div>
		    
		    {errors.phone && <p style={{color:"red"}}>Pole Telefon nemá správný formát</p>} 

<div className="form mb-3">  
<select className="form-select" style={{fontSize:"1.4em"}}  {...register('choice', { required: true})} multiple>
  <option value = "" disabled selected> Koupil/-a jsem si balíček/-y<span className="required">*</span></option>
  <option value="Žádnej">Žádnej</option>
  <option value="VŠE: Průběžný test/Komplet">VŠE: Průběžný test/Komplet</option>
  
  <option value="VŠE: Závěrečný test/Individuál">VŠE: Závěrečný test/Individuál</option>
  <option value="VŠE: Závěrečný test/Mini">VŠE: Závěrečný test/Mini</option>
  <option value="VŠE: Závěrečný test/Médium">VŠE: Závěrečný test/Médium</option>
  <option value="VŠE: Závěrečný test/Maxi">VŠE: Závěrečný test/Maxi</option>
  
  <option value="VŠE: Teoretická část/Lineární algebra ">VŠE: Teoretická část/Lineární algebra </option>
  <option value="VŠE: Teoretická část/Matematická analýza">VŠE: Teoretická část/Matematická analýza</option>
  <option value="VŠE: Teoretická část/Komplet">VŠE: Teoretická část/Komplet</option>
  
  <option value="VŠE: Studijní materiály/Lineární algebra">VŠE: Studijní materiály/Lineární algebra</option>
  <option value="VŠE: Studijní materiály/Matematická analýza">VŠE: Studijní materiály/Matematická analýza</option>
  <option value="VŠE: Studijní materiály/Komplet ">VŠE: Studijní materiály/Komplet </option>
  
  <option value="VŠCHT: Průběžný test 2/Komplet">VŠCHT: Průběžný test 2/Komplet</option>
  <option value="VŠCHT: Závěrečný test/Komplet">VŠCHT: Závěrečný test/Komplet</option>
  
</select>
<label>Vyberte jednu nebo více možností</label>
</div>                
  {errors.choice && <p style={{color:"red"}}>Pole Koupil/-a jsem si balíček je požadováno</p>}   

		    <div className="form-floating mb-3">                    
                    <textarea className="form-control" id="message" type="text" placeholder="" style={{height: "10rem"}}
                        {...register("libilo")}
                    />
		    <label>Líbilo se mi...</label>
		    </div>
		    */}
		    
{/*
<div className="form-floating mb-3">                    
                    <textarea className="form-control" id="message" type="text" placeholder="" style={{height: "10rem"}}
                        {...register("vylepseni")}
                    />
		    <label>Vylepšil/-a bych...</label>
		    </div>
			*/}
			
			<div className="form mb-3">  
<select className="form-select" style={{fontSize:"1.4em"}}  {...register('choice', { required: true})} >
  <option value = ""  selected disabled> Měl/-a bych zájem o materiály ze STATISTIKY (4ST201)?<span className="required">*</span></option>
  <option value="Ano">Ano</option>
  <option value="Ne">Ne</option>
  <option value="Je mi to jedno">Je mi to jedno</option>

  
</select>
{/*<label>Vyberte jednu nebo více možností</label>*/}
</div>                
  {errors.choice && <p style={{color:"red"}}>Pole Měl/-a bych zájem o materiály ze STATISTIKY (4ST201)? je požadováno</p>}
		    
		    <div className="form-floating mb-3"> 
<input type="hidden" readonly="readonly" {...register("msg2", { value: "správa z dotazníku" })} />
</div> 

<div className="form-floating mb-3"> 
	<p><input
              type="checkbox"
              name="selectCheckbox"
              id="selectCheckbox"
              {...register('checkBox', { required: true})}
              
            /> <label style={{color:"black"}}>Souhlasím s</label> <label><a data-bs-toggle="modal" href="#portfolioModalPrivacyPolicy">Zásady ochrany osobních údajů</a><span className="required" style={{color:"black"}}>*</span></label></p>

</div>
  {errors.checkBox && <p style={{color:"red"}}>Pole Souhlasím s Zásady ochrany osobních údajů je požadováno</p>}  
                
                <Button className="btn btn-primary btn-xl justify-center"  type="submit" >Odeslat</Button>
                
            </form>
        </div>
    )
}
